import { Masonry } from 'masonic';
import { useLocation } from 'react-router-dom';

import styles from './styles.module.css';
import type { TestimonialOrNews } from '../../View/NewsTestimonialsView/NewsTestimonialView';
import type { DITSLink } from '@redturtle/qubicaamf-theme/components/Blocks/Listing/DiveInTheSector/Slides';
import MasonryCard from './MasonryCard';
import LoadMorePagination from './LoadMorePagination';
import { Loader } from 'semantic-ui-react';
import { useMemo } from 'react';

export type MasonryItemProps = TestimonialOrNews & DITSLink;

interface MasonryProps {
  loadMore: () => void;
  totalItems: number;
  loading: boolean;
  items: MasonryItemProps[];
}

const MasonryTemplate = ({
  loadMore,
  totalItems,
  loading,
  items,
}: MasonryProps) => {
  const location = useLocation();
  const fixedKey = useMemo(() => {
    return items.length + location.pathname;
  }, [items, location.pathname]);
  return (
    <>
      <Masonry
        items={items}
        render={MasonryCard}
        maxColumnCount={3}
        columnGutter={20}
        key={fixedKey}
      />
      {loading && (
        <div className={styles.loaderContainer}>
          <Loader active />
        </div>
      )}
      {totalItems > items.length && (
        <div className={styles.loadMoreContainer}>
          <LoadMorePagination loadMore={loadMore} />
        </div>
      )}
    </>
  );
};
export default MasonryTemplate;
